import { Rescatable } from '../Rescatable';

export class EquipmentResume extends Rescatable {
  static _name = 'EquipmentResume';
  static pathRequest =
    'https://compragamer.com/angular/servicios/encontraTuEquipo/obtenerResumenEquipos.php';
  static pk: keyof EquipmentResume = 'id_producto';

  combos: null;
  con_OS: number;
  consumo: number;
  display: number;
  e_nivel_cpu: number;
  e_nivel_gpu: number;
  es_notebook: number;
  gpu_dedicada: number;
  hd: number;
  id_producto: number;
  imagen: string;
  nombre: string;
  optico: number;
  precio: number;
  ram: number;
  ssd: number;
  hdd: number;
  constructor(equipmentResume: EquipmentResume) {
    super(equipmentResume);
  }
}
